// extracted by mini-css-extract-plugin
export default {"pageHeroWrapper":"s0gPdb","heroContent":"h4xEtl"};